import { render, staticRenderFns } from "./OrderReceivingPrint.vue?vue&type=template&id=994ce89c&scoped=true&"
import script from "./OrderReceivingPrint.vue?vue&type=script&lang=js&"
export * from "./OrderReceivingPrint.vue?vue&type=script&lang=js&"
import style0 from "./OrderReceivingPrint.vue?vue&type=style&index=0&id=994ce89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994ce89c",
  null
  
)

export default component.exports